// @ts-ignore
import './styles.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// --- JOUW PAGINA'S ---
import Landing from './Landing';
import App from './App'; // Jouw bestaande applicatie / dashboard
import PrivacyNotice from './support/Privacy'; // <-- NIEUW: De privacy pagina ingeladen

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Als iemand naar bespanapp.nl (de root '/') gaat, toon de Landing component */}
        <Route path="/" element={<Landing />} />
        
        {/* Als iemand naar bespanapp.nl/dashboard gaat, toon de App component */}
        <Route path="/dashboard/*" element={<App />} />

        {/* NIEUW: Als iemand naar de privacy link gaat, toon het nieuwe document */}
        <Route path="/support/privacy" element={<PrivacyNotice />} />
        
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);